"use client";
import {useEffect, useState} from "react";
import PostCard from "@/components/SocialNetworks/Posts/PostCard";

export default function CommunitySection({postsActive, communitiesActive,activities, trainings,firstname,path,lastname }){
    const [posts, setPosts] = useState(postsActive);
    const [activeCom, setActiveCom] = useState(false);
    const [changeNow, setChangeNow] = useState(false);
    useEffect(() => {
        if(activeCom && changeNow){
           setPosts(postsActive.filter(el => el.community_id === activeCom));
           setChangeNow(false);
        }

        if(changeNow && !activeCom){
            setPosts(postsActive);
            setChangeNow(false);
        }
    }, [changeNow]);


    return(
        <>
            <aside className={"flex flex-wrap gap-x-4 gap-y-2 "}>
                {(communitiesActive && communitiesActive.length > 0) &&(
                    <>
                        {communitiesActive.map(function(com){
                            return(
                                <button
                                    key={com.id}
                                    onClick={() => {
                                        if(activeCom === com.id){
                                            setActiveCom(false);
                                        }else{
                                            setActiveCom(com.id);
                                        }
                                        setChangeNow(true);
                                    }}
                                    className={`flex flex-col items-center gap-y-1`}
                                >
                                    <img src={com.document.path} className={`rounded-full aspect-square w-14 h-14 border border-2 ${activeCom === com.id ? 'border-primary' : ''}`}/>
                                    <p className={"text-xs"}>{com.name.length > 10 ? com.name.substring(0,10) + "..." : com.name}</p>
                                </button>
                            )
                        })}
                    </>
                )}


            </aside>
            <aside className={"grid gap-4"}>
                {posts.length > 0
                    ?
                    <>
                        {posts?.map((post) => {
                            return (
                                <PostCard
                                    key={post.id}
                                    idPost={post.id}
                                    content={post.content}
                                    userId={post.user_id}
                                    activities={activities}
                                    activity={post.activity}
                                    actualUserId={0}
                                    comments={post.comments}
                                    createdAt={post.created_at}
                                    firstname={firstname}
                                    imageUser={path}
                                    lastname={lastname}
                                    likes={post.likes}
                                    medias={post.medias}
                                    training={post.training}
                                    trainings={trainings}
                                    editable={false}
                                />
                            )
                        })}
                    </>
                    :
                    <div className={"h-[35vh] flex flex-col justify-center items-center"}>
                        <p className={"italic"}>L&apos;utilisateur n&apos;a pas encore posté pour le moment...</p>
                    </div>


                }
            </aside>

        </>
    )
}